import React, { useEffect, useRef, useState } from "react";
import Grid from "@mui/material/Grid";
import Header from "./Header";
import { API, graphqlOperation } from "aws-amplify";
import {
  searchUserProfileDetails,
  getUserProfileDetails,
  searchCards,
  searchCardItems,
  listTblGradeMasters,
} from "../../graphql/queries";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import Stack from "@mui/material/Stack";
import Loader from "./Loader";
import { Helmet } from "react-helmet";
import { Box, Container, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { getSignedUrl } from "../auth/util/util";
import CustomDataGridTable from "../admin/components/customDataGridTable";
import "./MyStudents.css";
import fetchSearchItemsNextToken from "../../graphql/fetchSearchItemsNextToken";
import { updateCardItems } from "../../graphql/mutations";
import { CSVLink } from "react-csv";
import { baseURL } from "../auth/util/CustomConstants";
import fetchItemsNextToken from "../../graphql/fetchItemsNextToken";
import { set } from "date-fns";

function ProjectDashboard() {
  let navigate = useNavigate();

  // Toast message
  const [openToast, setOpenToast] = useState(false);
  const [toastMsg, setToastMsg] = useState("This is a success message!");
  const [severityClass, setSeverityClass] = useState("success");

  const [showLoader, setShowLoader] = useState(false);
  const [selectedImage, setSelectedImage] = useState(); //setting school logo
  const [referralCode, setReferralCode] = useState("");
  const [usersFromReferralCode, setUsersFromReferralCode] = useState([]);
  const [showTable, setShowTable] = useState(false);
  const gradingOption = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
  const cacheGrade = {}; //use for caching grade data of users
  const [gradeList, setGradeList] = useState([]);
  const csvLink = useRef();
  const [csvData, setCSVData] = useState([]);
  const csvHeaders = [
    { label: "Project Link", key: "title" },
    { label: "Profile Link", key: "name" },
    { label: "School Name", key: "schoolName" },
    { label: "Grade", key: "grade" },
    { label: "Score", key: "score" },
    { label: "Project Tags", key: "projectTags" },
    { label: "Created At", key: "createdAt" },
  ];
  const [rows, setRows] = useState([]);
  const columns = [
    {
      field: "title",
      headerName: "Project Title",
      width: 180,
      renderCell: (params) => {
        return (
          <a
            href={`/project/${params.row.username}/${params.row.id}?return=0`}
            target="_blank"
            style={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              maxWidth: "100%",
              color: "#04A5A6",
              cursor: "pointer",
              textDecoration: "none",
              fontWeight: "500",
            }}
            title={params.row.title}
          >
            {params.row.title}
          </a>
        );
      },
    },
    {
      field: "name",
      headerName: "Name",
      width: 200,
      renderCell: (params) => {
        return (
          <a
            href={`/profile/${params.row.username}`}
            target="_blank"
            style={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              maxWidth: "100%",
              color: "#04A5A6",
              cursor: "pointer",
              textDecoration: "none",
            }}
            title={params.row.name || params.row.username}
          >
            {params.row.name || params.row.username}
          </a>
        );
      },
    },
    {
      field: "schoolName",
      headerName: "School",
      width: 200,
      renderCell: (params) => {
        return (
          <div
            style={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              maxWidth: "100%",
            }}
            title={params.row.schoolName}
          >
            {params.row.schoolName}
          </div>
        );
      },
    },
    {
      field: "gradeSeq",
      headerName: "Grade",
      width: 110,
      renderCell: (params) => {
        return <div>{params.row.grade}</div>;
      },
    },
    {
      field: "score",
      headerName: "Score",
      width: 130,
      renderCell: (params) => {
        return (
          <div style={{ width: "100%" }}>
            {params.row.score !== null
              ? scoreDropDownComponent(params, "Change Score")
              : scoreDropDownComponent(params)}
          </div>
        );
      },
    },
    {
      field: "createdAt",
      headerName: "Created At",
      width: 155,
      renderCell: (params) => {
        return (
          <div>
            {new Date(params.row.createdAt).toLocaleString("en-GB", {
              day: "2-digit",
              month: "2-digit",
              year: "2-digit",
              hour: "2-digit",
              minute: "2-digit",
              hour12: true,
            })}
          </div>
        );
      },
    },
    {
      field: "projectTags",
      headerName: "Tags",
      width: 200,
      renderCell: (params) => {
        return (
          <div
            title={params.row.projectTags.join(", ")}
            className="project-tags"
            style={{
              display: "flex",
              width: "max-content",
              overflowX: "auto",
              whiteSpace: "nowrap",
            }}
          >
            {params.row.projectTags.length > 0 &&
              params.row.projectTags.map((tag) => {
                return (
                  <span
                    style={{
                      backgroundColor: "#04A5A6",
                      color: "#fff",
                      padding: "3px 6px",
                      margin: "4px",
                      borderRadius: "5px",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {tag}
                  </span>
                );
              })}
            {params.row.projectTags.length === 0 && <span>-</span>}
          </div>
        );
      },
    },
  ];

  // function to update score of project
  const scoreUpdate = async (e, id, data) => {
    try {
      setShowLoader(true);
      const score = parseInt(e.target.value);
      let newData = { ...data, score: score };

      if (!id) throw new Error("Project ID not found");

      const updateProject = await API.graphql(
        graphqlOperation(updateCardItems, {
          input: { id: id, newdata: JSON.stringify(newData) },
        })
      );

      if (!updateProject?.data?.updateCardItems)
        throw new Error("Error in updating project");

      let newRows = rows.map((row) => {
        if (row.id === id) {
          return { ...row, score: score, data: newData };
        }
        return row;
      });
      setRows(newRows);
      setToastMsg("Score updated successfully.");
      setSeverityClass("success");
      setOpenToast(true);
    } catch (e) {
      console.log("Error in scoreUpdate", e);
      setToastMsg("Something went wrong. Please try again later.");
      setSeverityClass("error");
      setOpenToast(true);
    } finally {
      setShowLoader(false);
    }
  };

  // function to create dropdown for score column
  const scoreDropDownComponent = (params, defaultText = "Not Scored") => {
    return (
      <select
        value={params.row.score}
        onChange={(e) => scoreUpdate(e, params.row.id, params.row.data)}
        style={{
          maxWidth: "110px",
          minWidth: "110px",
          backgroundColor: "#04A5A6",
          padding: "2px 5px",
          color: "#fff",
          borderRadius: "5px",
          border: "1px solid #04A5A6",
        }}
      >
        <option value={null}>{defaultText}</option>
        {gradingOption.map((grade) => (
          <option key={grade} value={grade}>
            {grade}
          </option>
        ))}
      </select>
    );
  };

  const handleCloseTost = () => {
    setOpenToast(false);
  };

  // function to check if user is admin
  const checkIfAdmin = async () => {
    setShowLoader(true);
    try {
      if (!localStorage.getItem("userDetailsID"))
        navigate(process.env.PUBLIC_URL + "/signin");

      const userData = await API.graphql(
        graphqlOperation(getUserProfileDetails, {
          id: localStorage.getItem("userDetailsID"),
        })
      ).then((res) => res?.data?.getUserProfileDetails);

      if (!userData) navigate(process.env.PUBLIC_URL + "/signin");
      if (userData.isAdmin == null)
        navigate(process.env.PUBLIC_URL + "/my-feed/");
      if (userData.adminLogo !== null) {
        getSignedUrl(userData.adminLogo, {
          level: "public",
        })
          .then(setSelectedImage)
          .catch((err) => console.log("Error in getting signed URL", err));
      }

      let _referralCode = userData?.referralCode || "";

      if (_referralCode === "") {
        setToastMsg(
          "Referral Code not found. Please fill the Referral Code in settings and try again later."
        );
        setSeverityClass("error");
        setOpenToast(true);
        return;
      }
      if (_referralCode && _referralCode !== "") {
        setReferralCode(_referralCode);
        await getUsersFromRefferalCode(_referralCode);
      }
    } catch (e) {
      console.log("Error in checkIfAdmin", e);
      setToastMsg("Something went wrong. Please try again later.");
      setSeverityClass("error");
      setOpenToast(true);
    } finally {
      setShowLoader(false);
    }
  };

  // function to get users from referral code
  const getUsersFromRefferalCode = async (_referralCode) => {
    try {
      if (!_referralCode) {
        setToastMsg(
          "Referral Code not found. Please fill the Referral Code in settings and try again later."
        );
        setSeverityClass("error");
        setOpenToast(true);
        return;
      }

      const users = await API.graphql(
        graphqlOperation(searchUserProfileDetails, {
          filter: { referralCode: { eq: _referralCode } },
        })
      );
      if (
        !users ||
        !users?.data?.searchUserProfileDetails?.items ||
        users?.data?.searchUserProfileDetails?.items.length === 0
      ) {
        setToastMsg(`No users found with ${_referralCode} referral code.`);
        setSeverityClass("error");
        setOpenToast(true);
        return;
      }

      const _usersFromReferralCode =
        users?.data?.searchUserProfileDetails?.items;
      setUsersFromReferralCode(_usersFromReferralCode);

      // fetch all grade data
      let gradeDataQuery = await fetchItemsNextToken({
        query: listTblGradeMasters,
        variables: { filter: { status: { eq: 1 } } },
      });
      let getGradeData = gradeDataQuery.filter(
        (item) => item._deleted !== true
      );
      if (getGradeData.length > 0) {
        setGradeList(getGradeData);
      }
    } catch (e) {
      console.log("Error in getUsersFromRefferalCode", e);
      setToastMsg("Something went wrong. Please try again later.");
      setSeverityClass("error");
      setOpenToast(true);
    } finally {
      setShowLoader(false);
    }
  };

  // once the grade list is fetched, get all projects of users
  useEffect(() => {
    if (gradeList.length > 0) {
      getProjectsOfUsers(usersFromReferralCode);
    }
  }, [gradeList]);

  // function to get all projects of users from referral code
  const getProjectsOfUsers = async (_usersFromReferralCode) => {
    setShowLoader(true);
    setShowTable(false);
    try {
      let subArrSize = 30;
      let usersSubArr = [];
      if (!_usersFromReferralCode || _usersFromReferralCode.length === 0) {
        setToastMsg(`No users found with ${referralCode} referral code.`);
        setSeverityClass("error");
        setOpenToast(true);
        return;
      }

      // generate filter for search cards
      let searchCardsFilter = _usersFromReferralCode.map((user) => {
        return {
          userprofiledetailsID: { eq: user.id },
          title: { eq: "portfolio" },
        };
      });
      let noOfSubArr = Math.ceil(_usersFromReferralCode.length / subArrSize);
      // divide array into sub arrays
      for (let i = 0; i < noOfSubArr; i++) {
        let start = i * subArrSize;
        let end = (i + 1) * subArrSize;
        let subArr = searchCardsFilter.slice(start, end);
        usersSubArr.push(subArr);
      }
      const _projectCard = await Promise.all(
        usersSubArr.map(async (subArr) => {
          return await fetchSearchItemsNextToken({
            query: searchCards,
            variables: { filter: { or: subArr } },
          });
        })
      ).then((res) => res.flat());
      if (!_projectCard || !_projectCard?.length > 0) return;

      // once we have all project cards, get all project items
      let searchCardItemsFilter = _projectCard.map((project) => {
        return {
          cardID: { eq: project.id },
          status: { eq: 1 },
          restricted: { ne: 1 },
        };
      });
      noOfSubArr = Math.ceil(searchCardItemsFilter.length / subArrSize);
      let _projectsSubArr = [];
      for (let i = 0; i < noOfSubArr; i++) {
        let start = i * subArrSize;
        let end = (i + 1) * subArrSize;
        let subArr = searchCardItemsFilter.slice(start, end);
        _projectsSubArr.push(subArr);
      }
      const _projects = await Promise.all(
        _projectsSubArr.map(async (subArr) => {
          return await fetchSearchItemsNextToken({
            query: searchCardItems,
            variables: { filter: { or: subArr } },
          });
        })
      ).then((res) => res.flat());
      if (!_projects || !_projects?.length > 0) return;

      // get all project data and populate the table
      let finalData = [];
      for (let i = 0; i < _projects.length; i++) {
        let project = _projects[i];
        if (project?.cardID && project?.cardID !== "") {
          let projectCard = _projectCard.find(
            (card) => card.id === project.cardID
          );
          let projectData = JSON.parse(project.newdata);
          let projectTitle = projectData?.title || "";
          let user = _usersFromReferralCode.find(
            (user) => user.id === projectCard.userprofiledetailsID
          );
          let currentGrade = await getCurrentGrade(user?.id);
          let projectTags =
            projectData?.projectTags &&
            JSON.parse(projectData.projectTags)?.length > 0
              ? JSON.parse(projectData.projectTags)
              : [];
          finalData.push({
            id: project.id,
            cardID: project.cardID,
            title: projectTitle,
            username: user?.username || "-",
            name: `${user?.first_name || ""} ${user?.last_name}` || "",
            schoolName: user?.school_name || "-",
            grade: currentGrade?.title || "-",
            gradeSeq: currentGrade?.seq || 0,
            userProfileDetailsID: user?.id || "",
            createdAt: project.createdAt,
            updatedAt: project.updatedAt,
            score: projectData?.score || null,
            projectTags: projectTags,
            data: projectData,
          });
        }
      }
      setRows(finalData);
      setShowLoader(false);
      setShowTable(true);
    } catch (e) {
      console.log("Error in getProjectsOfUsers", e);
      setToastMsg("Something went wrong. Please try again later.");
      setSeverityClass("error");
      setOpenToast(true);
    } finally {
      setShowLoader(false);
    }
  };

  const getCurrentGrade = async (_userProfileDetailsID) => {
    if (cacheGrade[_userProfileDetailsID])
      return cacheGrade[_userProfileDetailsID];
    let cardDataQuery = await fetchSearchItemsNextToken({
      query: searchCards,
      variables: {
        filter: {
          userprofiledetailsID: { eq: _userProfileDetailsID },
          title: { eq: "education" },
        },
      },
    });
    if (!(cardDataQuery.length > 0)) return null;

    let cardItemDataQuery = await fetchSearchItemsNextToken({
      query: searchCardItems,
      variables: {
        filter: { cardID: { eq: cardDataQuery[0].id }, status: { eq: 1 } },
        limit: 500,
      },
    });
    if (!(cardItemDataQuery.length > 0)) return null;

    let getCardItemData = cardItemDataQuery.sort((a, b) =>
      b.createdAt.localeCompare(a.createdAt)
    );

    let currentlyStudy = getCardItemData.filter(
      (item) => JSON.parse(item.newdata).currentlyStudying === true
    );
    if (currentlyStudy.length > 0) {
      let gradeData = JSON.parse(currentlyStudy[0].newdata);
      let response = await fetchGrade(gradeData.endGrade);
      cacheGrade[_userProfileDetailsID] = response;
      return response;
    } else {
      let gradeData = JSON.parse(getCardItemData[0].newdata);
      let response = await fetchGrade(gradeData.endGrade);
      cacheGrade[_userProfileDetailsID] = response;
      return response;
    }
  };

  const fetchGrade = async (id) => {
    let gradeListData = gradeList.filter((item) => item.id == id);
    if (gradeListData.length > 0) {
      let grade = ordinal_suffix_of(gradeListData[0].grade_name);
      return { title: grade, seq: gradeListData[0].series };
    } else {
      return "";
    }
  };

  function ordinal_suffix_of(i) {
    if (!isNaN(i)) {
      var j = i % 10,
        k = i % 100;
      if (j == 1 && k != 11) {
        return i + "st Grade";
      }
      if (j == 2 && k != 12) {
        return i + "nd Grade";
      }
      if (j == 3 && k != 13) {
        return i + "rd Grade";
      }
      if (i) {
        return i + "th Grade";
      } else {
        return i;
      }
    } else {
      return i;
    }
  }

  // function to generate and download CSV file
  const exportCSV = async () => {
    try {
      setShowLoader(true);
      for (let i = 0; i < rows.length; i++) {
        let grade = await getCurrentGrade(rows[i].userProfileDetailsID);
        rows[i].grade = grade?.title || "-";
      }
      let tempRows = rows.map((e, i) => {
        return {
          title: `${baseURL}/project/${e.username}/${e.id}?return=0`,
          name: `${baseURL}/profile/${e.username}`,
          schoolName: e.schoolName,
          grade: e.grade || "-",
          score: e.score || "Not Scored",
          projectTags: e.projectTags.join(", "),
          createdAt: new Date(e.createdAt).toLocaleString("en-GB", {
              day: "2-digit",
              month: "2-digit",
              year: "2-digit",
              hour: "2-digit",
              minute: "2-digit",
              hour12: true,
            }),
        };
      });
      setCSVData(tempRows);
      setTimeout(() => {
        if (!csvLink?.current?.link) throw new Error("CSV Link not found");
        csvLink.current.link.click();
      }, 1000);
    } catch (error) {
      console.log("Error in exportCSV", error);
      setToastMsg("Something went wrong. Please try again later.");
      setSeverityClass("error");
      setOpenToast(true);
    } finally {
      setShowLoader(false);
    }
  };

  useEffect(() => {
    checkIfAdmin();
  }, []);

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Project Dashboard - MySphere</title>
      </Helmet>
      <Header />
      <Loader visible={showLoader} />

      <div className="custom_container">
        <Stack spacing={2} sx={{ width: "100%" }}>
          <Snackbar
            open={openToast}
            autoHideDuration={2000}
            onClose={handleCloseTost}
          >
            <Alert
              variant="filled"
              onClose={handleCloseTost}
              severity={severityClass}
              sx={{ width: "100%" }}
            >
              {toastMsg}
            </Alert>
          </Snackbar>
        </Stack>

        <Box>
          <Box className="page_heading_cv">
            <Grid container>
              <Grid item md={10}>
                <Typography variant="h1" my={2}>
                  Project Dashboard
                </Typography>
              </Grid>
              <Grid item md={2}>
                <Box
                  sx={{ textAlign: { sm: "start", md: "end" } }}
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <span>
                    <button
                      onClick={exportCSV}
                      style={{
                        maxWidth: "100px",
                        minWidth: "100px",
                        height: "40px",
                        backgroundColor: "#04A5A6",
                        padding: "5px 3px",
                        margin: "0 10px",
                        color: "#fff",
                        borderRadius: "5px",
                        border: "1px solid #04A5A6",
                      }}
                    >
                      Download all
                    </button>
                  </span>
                  {selectedImage && (
                    <img src={selectedImage} alt="School Logo" width={140} />
                  )}
                </Box>
              </Grid>
            </Grid>
          </Box>

          <Box pt={3}>
            <Box pl={2} className="">
              <Grid container>
                <Grid item xs={12} md={12}>
                  <Container
                    style={{
                      backgroundColor: "#fff",
                      padding: "20px",
                      borderRadius: "10px",
                    }}
                  >
                    <CustomDataGridTable
                      rows={rows}
                      columns={columns}
                      showTable={showTable}
                      loading={showLoader}
                      message="No Projects found"
                      initialState={{
                        pagination: {
                          paginationModel: { page: 0, pageSize: 20 },
                        },
                      }}
                      disableRowSelectionOnClick
                      options={{ sorting: true }}
                      pageSizeOptions={[10, 20]}
                    />
                  </Container>
                </Grid>
              </Grid>
            </Box>
          </Box>
        </Box>
      </div>
      <CSVLink
        headers={csvHeaders}
        data={csvData}
        filename={`Project Submissions.csv`}
        className="hidden"
        ref={csvLink}
        target="_blank"
      />
    </>
  );
}

export default ProjectDashboard;
